// cart-bar.js

class CartBar extends HTMLElement {
	constructor() {
		super();
		this.selectors = {
			template: 'template',
			stepLine: '.step-line',
			text: '.cart-bar__text',
			progressBar: '.cart-bar__progress',
			barStep: '.bar-step',
			iconDelivery: '.icon--cart-delivery-truck',
			iconGift: '.icon--cart-gift',
			iconDiscount: '.icon--cart-discount',
			iconCheck: '.icon--cart-check',
		};
		this.cartBarLevels = window.cartBarLevels;
		this.template = this.querySelector(this.selectors.template);
		this.cartBarProgress = this.querySelector(this.selectors.progressBar);
		this.initialRender();
	}

	initialRender() {
		this.cartBarLevels.sort((a, b) => a.threshold - b.threshold);
		this.cartBarLevels.forEach((level, index) => {
			const iconSelectorMap = {
				shipping: this.selectors.iconDelivery,
				gift: this.selectors.iconGift,
				discount: this.selectors.iconDiscount,
			};

			const iconSelector = iconSelectorMap[level.type];
			if (!iconSelector) return;

			const cartBarStep = this.template.content.querySelector(this.selectors.barStep)?.cloneNode(true);
			const cartBarIcon = this.template.content.querySelector(iconSelector)?.cloneNode(true);

			if (cartBarStep) {
				if (cartBarIcon) {
					cartBarStep.children[0].prepend(cartBarIcon);
				}
				const positionLeft = `${(index + 1) / (this.cartBarLevels.length + 1)}%`;
				cartBarStep.style.setProperty('--position-left', positionLeft);
				this.cartBarProgress.prepend(cartBarStep);
				level.position = (index + 1) / (this.cartBarLevels.length + 1);

				if (this.totalPrice >= level.threshold) {
					const stepLine = cartBarStep.querySelector(this.selectors.stepLine);
					if (stepLine) {
						stepLine.classList.add('active');
					}
				}
			}
		});
	}

	connectedCallback() {
		this.renderProgress();
		this.renderText();
	}

	renderProgress() {
		const progress = this.calcProgress(this.totalPrice);
		this.style.setProperty('--progress', `${window.cartBarProgress}%`);
		window.cartBarProgress = progress;
		setTimeout(() => {
			this.style.setProperty('--progress', `${progress}%`);
		}, 50);
	}

	renderText() {
		const end = this.cartBarLevels.find((mappedThreshold) => this.totalPrice < mappedThreshold.threshold);
		if (!end) {
			this.querySelector(this.selectors.text).innerText = window.allLevelsReachedText;
			return;
		}
		const remainingAmount = (end.threshold - this.totalPrice) / 100;
		const remainingAmountCurrency = new Intl.NumberFormat('en-IN', { style: 'currency', currency: this.currency })
			.format(remainingAmount)
			.replace('.', ',');
		const remainingText = end.remainingText.replace('{xx}', remainingAmountCurrency);
		this.querySelector(this.selectors.text).innerText = remainingText;
	}

	calcProgress(totalPrice) {
		const activeThreshold = this.cartBarLevels.filter((mappedThreshold) => totalPrice >= mappedThreshold.threshold);
		const start = activeThreshold[activeThreshold.length - 1];
		const end = this.cartBarLevels.find((mappedThreshold) => totalPrice < mappedThreshold.threshold);
		if (!end) {
			return 100;
		}
		const startThreshold = start ? start.threshold : 0;
		const endThreshold = end.threshold;
		const nextLevelPosition = end.position * 100;
		const previousLevelPosition = start ? start.position * 100 : 0;
		const progressBetweenPreviousAndNextLevel = (totalPrice - startThreshold) / (endThreshold - startThreshold);
		const progress =
			previousLevelPosition + progressBetweenPreviousAndNextLevel * (nextLevelPosition - previousLevelPosition);
		return progress;
	}

	get totalPrice() {
		return parseInt(this.getAttribute('total-price'));
	}

	get currency() {
		return this.getAttribute('currency');
	}
}

if (!window.customElements.get('cart-bar')) {
	window.customElements.define('cart-bar', CartBar);
}
